// extracted by mini-css-extract-plugin
module.exports = {"title":"Contact_title__1Ekl7","grid":"Contact_grid__3Jdxw"};